import type { SettingsSection } from '@church/data'
import {
  faChurch,
  faCircleUser,
  faClockRotateLeft,
  faEnvelopeOpenText,
  faFileImport,
  faInputText,
  faLaptopCode,
  faLocationDot,
  faMusic,
  faPeopleGroup,
  faShieldHalved,
  faTags,
  faUserShield,
  faWallet,
  type IconData,
} from '@church/ui-icons'

/** Settings' sections, in order: where each lives and its tab (the screens are in routes/). */
export const SETTINGS_TABS = [
  { to: '/settings/profile', label: 'Profile', icon: faChurch, section: 'profile' },
  { to: '/settings/campuses', label: 'Campuses', icon: faLocationDot, section: 'campuses' },
  { to: '/settings/tags', label: 'Tags & notes', icon: faTags, section: 'tags' },
  {
    to: '/settings/custom-fields',
    label: 'Custom fields',
    icon: faInputText,
    section: 'customFields',
  },
  {
    to: '/settings/group-types',
    label: 'Group types',
    icon: faPeopleGroup,
    section: 'groupTypes',
  },
  { to: '/settings/staff', label: 'Staff & roles', icon: faUserShield, section: 'staff' },
  {
    to: '/settings/invitations',
    label: 'Invitations',
    icon: faEnvelopeOpenText,
    section: 'invitations',
  },
  { to: '/settings/roles', label: 'Roles', icon: faShieldHalved, section: 'roles' },
  { to: '/settings/billing', label: 'Billing', icon: faWallet, section: 'billing' },
  {
    to: '/settings/developers',
    label: 'API & webhooks',
    icon: faLaptopCode,
    section: 'developers',
  },
  {
    to: '/settings/planning-center',
    label: 'Planning Center',
    icon: faFileImport,
    section: 'planningCenter',
  },
  { to: '/settings/services', label: 'ForServices', icon: faMusic, section: 'services' },
  { to: '/settings/account', label: 'Account', icon: faCircleUser, section: 'account' },
  {
    to: '/settings/audit-log',
    label: 'Audit log',
    icon: faClockRotateLeft,
    section: 'auditLog',
  },
] as const satisfies readonly {
  to: string
  label: string
  icon: IconData
  section: SettingsSection
}[]
